export default __webpack_public_path__ + "static/franchise1-5ccfb87078b8b1e59f505922d7af35a7.png";